import { apiPost } from "@/core/api";
import { Citizen, Core, GeorgiaDfcsBenefits, Identification } from "@minicity/core";

export interface CreateApplicationRequest {
    citizenId: string;
    formData: GeorgiaDfcsBenefits.FormData;
    supportDocuments: Core.Document[];
    signatures: {[key: string]: Core.Document},
    draftApplicationId?: string;

    notificationPreferences: Citizen.NotificationPreferences;

    idempotencyToken: string;
}

export interface CreateApplicationResponse {
    id: string;
}

export const submitApplication = (req: CreateApplicationRequest) => {
    return apiPost<CreateApplicationResponse>("applications/georgiaDfcsBenefits", req);
}